"use client";
import { persistentAtom } from "@nanostores/persistent";
import { atom } from "nanostores";
import { KEY_REALM, KEY_PKCE_STATE, KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN, KEY_ACCESS_TOKEN_EXP, KEY_REFRESH_TOKEN_EXP, KEY_PKCE_CODE_VERIFIER, } from "./constants";
export const realm = persistentAtom(KEY_REALM, "");
export const pkceState = persistentAtom(KEY_PKCE_STATE, "");
export const accessToken = persistentAtom(KEY_ACCESS_TOKEN, "");
export const refreshToken = persistentAtom(KEY_REFRESH_TOKEN, "");
export const accessTokenExp = persistentAtom(KEY_ACCESS_TOKEN_EXP, "");
export const refreshTokenExp = persistentAtom(KEY_REFRESH_TOKEN_EXP, "");
export const pkceCodeVerifier = persistentAtom(KEY_PKCE_CODE_VERIFIER, "");
export const realmConfig = atom(null);
export const openIdConfig = atom(null);
export const refreshTimer = atom(0);
export const logoutTimer = atom(0);
//# sourceMappingURL=store.js.map